// @ToDo: use persistance storage or composable from vue use
const storage = {
  get(key, parsed = false) {
    const item = localStorage.getItem(key)
    if (!item) return null

    return parsed ? JSON.parse(item) : item
  },
  set(key, value, stringify = false) {
    const item = stringify ? JSON.stringify(value) : value
    localStorage.setItem(key, item)
  },
  delete(key) {
    if (localStorage.getItem(key) !== null) {
      localStorage.removeItem(key)
    }
  }
}

export default storage
